import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Nationalities, INationalities } from '@static/nationalities';
import { PaymentFrequency, IFrequency } from '@static/payment-frequency';
import { Salutations, ISalutation } from '@static/salutation';
import { NamingGuidelineTemplate, INamingGuideline } from '@static/naming-guidelines';
import { ContactInformation, IContactInfo } from '@static/contact-information';
import { IBusiness, Business } from '@static/businesses';
import { ISource, SourceOfFunds, SourceOfWealths } from '@static/sources';
import { IPremiumTerm, PremiumTerms } from '@static/premium-term';
import { DeclinedOccupations } from '@static/declined-occupations';
import { Races, IRace } from '@static/races';
import { MaritalStatus, IMaritalStatus } from '@static/marital-status';
import { IOccupation } from './model';
import { IBank, Banks } from '@static/banks';
export interface StaticState {
  nationlaities: INationalities[];
  sioOccupations: IOccupation[] | null;
  dpiOccupations: IOccupation[] | null;
  paymentFrequency: IFrequency[];
  salutations: ISalutation[];
  namingGuideline: INamingGuideline,
  contactInformation: IContactInfo[],
  businesses: IBusiness[],
  sourceOfFunds: ISource[],
  sourceOfWealths: ISource[],
  premiumTerms: IPremiumTerm[],
  declinedOccupations: IOccupation[],
  maritalStatus: IMaritalStatus[],
  races: IRace[],
  banks: IBank[],
  brochureUrl: string;
}

const initialState: StaticState = {
  nationlaities: Nationalities,
  sioOccupations: null,
  dpiOccupations: null,
  paymentFrequency: PaymentFrequency,
  salutations: Salutations,
  namingGuideline: NamingGuidelineTemplate,
  contactInformation: ContactInformation,
  businesses: Business,
  sourceOfFunds: SourceOfFunds,
  sourceOfWealths: SourceOfWealths,
  premiumTerms: PremiumTerms,
  declinedOccupations: DeclinedOccupations,
  maritalStatus: MaritalStatus,
  races: Races,
  banks: Banks,
  brochureUrl: '',
}

const staticSlice = createSlice({
  name: 'GLOBAL-static',
  initialState,
  reducers: {
    updateSIOOccupations: (state, action: PayloadAction<IOccupation[]>) => {
      state.sioOccupations = action.payload;
    },
    updateDPIOccupations: (state, action: PayloadAction<IOccupation[]>) => {
      state.dpiOccupations = action.payload;
    },
    updateBanks: (state, action: PayloadAction<IBank[]>) => {
      state.banks = action.payload;
    },
    updateBrochureUrl: (state, action: PayloadAction<string>) => {
      state.brochureUrl = action.payload
    },
  },
  extraReducers: {}
});

export const  { updateSIOOccupations, updateDPIOccupations, updateBanks, updateBrochureUrl } = staticSlice.actions;

export default staticSlice.reducer;